import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { nextTick as t } from "./nextTick.js";

var s = /*#__PURE__*/function () {
  function s(t) {
    _classCallCheck(this, s);

    this.allocator = t, this._items = [], this._itemsPtr = 0, this.grow();
  }

  _createClass(s, [{
    key: "get",
    value: function get() {
      var _this = this;

      return 0 === this._itemsPtr && t(function () {
        return _this.reset();
      }), this._itemsPtr === this._items.length && this.grow(), this._items[this._itemsPtr++];
    }
  }, {
    key: "reset",
    value: function reset() {
      var t = Math.min(3 * Math.max(8, this._itemsPtr), this._itemsPtr + 3 * i);
      this._items.length = Math.min(t, this._items.length), this._itemsPtr = 0;
    }
  }, {
    key: "grow",
    value: function grow() {
      for (var _t = 0; _t < Math.max(8, Math.min(this._items.length, i)); _t++) {
        this._items.push(this.allocator());
      }
    }
  }]);

  return s;
}();

var i = 1024;
export { s as ObjectStack };